"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPER_DEAL = exports.OFFER = exports.NEW_EDITION_LABEL = exports.NEW_EDITION_AVAILABLE_LABEL = exports.NEW_EDITION_AVAILABLE = exports.NEW_EDITION = exports.NEW = exports.LABEL_SUPER_DEAL = exports.LABEL_OFFER = exports.LABEL_NEW = exports.DEAL_LABEL = void 0;
const DEAL_LABEL = exports.DEAL_LABEL = 'deal';
const LABEL_OFFER = exports.LABEL_OFFER = 'LabelOffer';
const LABEL_NEW = exports.LABEL_NEW = 'LabelNew';
const LABEL_SUPER_DEAL = exports.LABEL_SUPER_DEAL = 'LabelSuperDeal';
const NEW_EDITION_LABEL = exports.NEW_EDITION_LABEL = 'new-edition';
const NEW_EDITION_AVAILABLE_LABEL = exports.NEW_EDITION_AVAILABLE_LABEL = 'new-edition-available';
const OFFER = exports.OFFER = 'Offer';
const NEW = exports.NEW = 'New';
const SUPER_DEAL = exports.SUPER_DEAL = 'SuperDeal';
const NEW_EDITION = exports.NEW_EDITION = 'NewEdition';
const NEW_EDITION_AVAILABLE = exports.NEW_EDITION_AVAILABLE = 'NewEditionAvailable';
//# sourceMappingURL=dealLabel.js.map